import { Card, Flex, Statistic } from 'antd';
import { useGetDistributionEfficiencyAggregatedStatistics } from 'api/statistic/use-get-distribution-efficiency-aggregated-statistics';
import { useFleetInsightsFiltersStore } from 'shared/stores/use-fleet-insights-filters';
import { WarehouseFormSelect } from 'components/common/warehouse-form-select';
import styles from './company-stats.module.scss';
import type { ICompanyStatsProps } from './types';

export const CompanyStats = (props: ICompanyStatsProps) => {
  const { date, onChange } = props;
  const { filters } = useFleetInsightsFiltersStore();
  const { warehouseId } = filters;

  const { data: speedData } = useGetDistributionEfficiencyAggregatedStatistics({
    filters: { date, warehouseId },
  });

  return (
    <Flex gap={16} vertical>
      <WarehouseFormSelect
        name='warehouseId'
        label='Warehouse'
        placeholder='Warehouse'
        handleChange={onChange}
        allowClear={false}
        withDeprecated={false}
        className={styles.warehouseSelect}
        internalOnly
      />
      <Flex gap={16} wrap='wrap' align='flex-start'>
        <Card>
          <Statistic
            title='Time until arrival'
            value={speedData?.value?.timeUntilArrival ?? 0}
            suffix='h'
            precision={1}
          />
        </Card>
        <Card>
          <Statistic
            title='Time until delivery'
            value={speedData?.value?.timeUntilDelivery ?? 0}
            suffix='h'
            precision={1}
          />
        </Card>
      </Flex>
    </Flex>
  );
};
